import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    /*{
      path: '/Chat',
      name: 'chat',
      component: () => import('./views/Chat.vue')
    },*/
    {
      path: '/ChatDesign',
      name: 'ChatDesign',
      component: () => import('./views/ChatDesign.vue')
    },
    {
      path: '/Plot',
      name: 'PlotView',
      component: () => import('./views/PlotView.vue')
    },
    {
      path: '/User',
      name: 'User',
      component: () => import('./views/User.vue')
    },
    {
      path: '/Tasks',
      name: 'Tasks',
      component: () => import('./views/newTaskManager.vue')
    },
    {
      path: '/Files',
      name: 'Files',
      component: () => import('./views/Files.vue')
    },
    {
      path: '/Analysis',
      name: 'Analysis',
      component: () => import('./views/Analysis.vue')
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: () => import('./views/Dashboard.vue')
    },
    {
      path: '/ForgotPassword',
      name: 'forgotpassword',
      component: () => import('./views/Password.vue')
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('./views/Settings.vue'),
      props: (route) => ({ foo: route.query.foo })
    },
    {
      path: '/auth_success',
      name: 'auth_success',
      component: () => import('./views/Auth_success.vue')
    },
    /*
    {
      path: '/Confirm',
      name: 'confirm',
      component: () => import('./views/Confirm.vue')
    }, 
    {
      path: '/Register',
      name: 'Register',
      component: () => import('./views/register.vue')
    },
    {
      path: '/processSetup',
      name: 'ProcessSetup',
      component: () => import('./views/processSetup.vue')
    },
    {
      path: '/health',
      name: 'Health',
      component: () => import('./views/health.vue')
    },*/
  ]
})
